const blogService = {
  getAllBlogs: async () => {
    const response = await fetch("https://tourvn.runasp.net/api/blog");
    if (!response.ok) throw new Error("Lỗi khi gọi API");
    return await response.json();
  },

  getBlogById: async (id) => {
    const response = await fetch(`https://tourvn.runasp.net/api/blog/${id}`);
    if (!response.ok) throw new Error("Lỗi khi gọi API");
    const data = await response.json();
    if (!data || Object.keys(data).length === 0)
      throw new Error("Bài viết không tồn tại");
    return data;
  },

  getBlogsByUserId: async (userId) => {
    const response = await fetch(
      `https://tourvn.runasp.net/api/blog/user/${userId}`
    );
    if (!response.ok)
      throw new Error("Lỗi khi lấy danh sách bài viết theo người dùng");
    return await response.json();
  },

  getActiveAndInactiveBlogs: async () => {
    const response = await fetch("https://tourvn.runasp.net/api/blog/status");
    if (!response.ok)
      throw new Error(
        "Lỗi khi lấy danh sách bài viết hoạt động và không hoạt động"
      );
    return await response.json();
  },

  createBlog: async (blogData) => {
    const response = await fetch("https://tourvn.runasp.net/api/blog/create", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(blogData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Lỗi khi tạo blog");
    }

    return await response.json();
  },

  updateBlog: async (id, blogData) => {
    const response = await fetch(
      `https://tourvn.runasp.net/api/blog/update-blog/${id}`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(blogData),
      }
    );
    if (!response.ok) throw new Error("Lỗi khi cập nhật blog");
    return await response.json();
  },

  deleteBlog: async (id) => {
    const response = await fetch(
      `https://tourvn.runasp.net/api/blog/delete-blog/${id}`,
      {
        method: "DELETE",
      }
    );
    if (!response.ok) throw new Error("Lỗi khi xóa blog");
    return true;
  },

  toggleBlogStatus: async (id) => {
    const response = await fetch(
      `https://tourvn.runasp.net/api/blog/toggle-status/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error("Không thể thay đổi trạng thái blog");
    }
    return await response.json();
  },
};

export default blogService;
